<template>
  <v-container id="credentials_root" fluid>
    <!-- DIALOG -->
    <router-view name="dialog"></router-view>

    <!-- CONTENT -->
    <v-row class="mb-6 px-6" align="center" justify="center">
      <v-col cols="7">
        <span class="text-h5">
          {{ $t('credentials.title.ImportedCredentials') }}
        </span>
      </v-col>

      <v-col class="d-flex flex-row align-self-end" align="sretch">
        <!--  <v-tooltip :disabled="disableWhenadminOnlyCredentialManagement" top>
          <template #activator="{ on }">
            <div class="d-flex flex-row align-self-end" v-on="on">
              <v-btn id="create_credential_button" :disabled="!disableWhenadminOnlyCredentialManagement" class="align-self-end mr-8" color="primary" to="/credentialsRSSP/add">
                <v-icon left>mdi-plus-circle-outline</v-icon>
                <span class="ml-2 text-capitalize">{{ $t('credentials.content.createCredential') }}</span>
              </v-btn>
            </div>
          </template>
<span v-if="!disableWhenadminOnlyCredentialManagement">{{ $t('credentials.content.createCredentialDisabledTooltip')
  }}</span>
</v-tooltip> -->

        <v-text-field
          id="search" v-model="search" :label="$t('dataTable.search')" append-icon="mdi-magnify" single-line
          hide-details clearable
        >
        </v-text-field>
      </v-col>
    </v-row>

    <v-card class="pa-5">
      <v-data-table
        id="credentials_table" must-sort :search="search" :headers="_headers" :items="credentialList"
        :page="pageNum" :options.sync="pagination" :server-items-length="totalItems" :loading="dataTableLoading"
        :loading-text="$t('dataTable.content.loadingPleaseWait')"
        :item-class="() => 'credentialsRow'"
        :no-data-text="$t('dataTable.content.noDataAvailable')" :footer-props="{
          'items-per-page-text': $t('dataTable.footer.itemsPerPageText'),
          'page-text': $t('dataTable.footer.pageText'),
          'items-per-page-options': [10, 25, 50]
        }" @update:page="pageChange" @update:sort-by="sortTable" @update:sort-desc="sortTable"
      >
        <template #[`item.description`]="{ item }">
          <long-text id="description" :text="item.description" :max-char="!isAdmin ? 55 : 30" />
        </template>

        <template #[`item.authMode`]="{ item }">
          <span id="auth_mode">{{ getAuthModeText(item) }}</span>
        </template>

        <template #[`item.email`]="{ item }">
          <long-text id="email" :text="item.user?.email || ''" />
        </template>

        <template #[`item.actions`]="{ item }">
          <v-menu offset-y absolute :close-on-content-click="false">
            <template #activator="{ on }">
              <v-btn id="more" text class="pa-1 " v-on="on">
                <v-icon>mdi-dots-horizontal</v-icon>
                {{ $t('dataTable.content.action.more') }}
              </v-btn>
            </template>
            <v-list id="actions_list">
              <v-tooltip :disabled="disableWhenadminOnlyCredentialManagement" right>
                <template #activator="{ on }">
                  <div class="d-inline" v-on="on">
                    <v-list-item
                      id="delete" :disabled="!disableWhenadminOnlyCredentialManagement"
                      @click="deleteCredential(item.id, $event)"
                    >
                      <v-list-item-title>{{ $t('dataTable.content.action.delete') }}</v-list-item-title>
                      <v-list-item-icon>
                        <v-icon>mdi-delete</v-icon>
                      </v-list-item-icon>
                    </v-list-item>
                  </div>
                </template>
                <span>{{ $t('credentials.content.createCredentialDisabledTooltip') }}</span>
              </v-tooltip>
            </v-list>
          </v-menu>
        </template>
      </v-data-table>
    </v-card>
  </v-container>
</template>

<script>
import debounce from 'lodash.debounce'
import { mapGetters } from 'vuex'
import Role from '../../Role'
import LongText from '../../components/LongText.vue'
import { showConfirmationMenu, showToastError, showToastSuccess } from '../../event-bus'
import credentialRefs from '../../services/api/credentialRefs'
import rsspUtil from '../../services/api/rsspUtil'
import AuthMode from './AuthMode'
import CredentialStatus from './CredentialStatus'

export default {
  name: 'ImportedCredentialsAdmin',

  components: {
    LongText
  },

  data() {
    return {
      search: null,
      sortDesc: true,
      pageNum: 1,
      sortBy: ['createdAt'],
      pagination: {
        sortBy: ['createdAt'],
        sortDesc: [true]
      },
      passwordMinCharacters: 6,
      credentialList: [],
      totalItems: 0,
      isAdminUser: false,
      dataTableLoading: false,
      authorizationModalFormValid: false,
      credentialTableActivationBtnLoading: {},
      show: false,
      selectedCredential: null,
      selectedCredentialOperation: null,
      authorizationTimeoutMilis: this.$store.state.remoteConfig.authorizationTimeoutSecs * 1000,
      credentialOperation: {
        ACTIVATE: 'activate',
        CHANGE_PASSWORD: 'changePassword',
        UNLOCK: 'unlock',
        CHANGE_PUK: 'changePuk'
      },
      expAuthPwd: {
        oldPwd: null,
        showOldPwd: false,
        pwd: null,
        showPwd: false,
        rePwd: null,
        showRePwd: false
      },
      generatedPukModal: false,
      formattedPuk: null,
      headers: [
        {
          text: this.$t('dataTable.header.credentials.description'),
          align: 'left',
          value: 'description',
          show: true
        },
        {
          text: this.$t('dataTable.header.credentials.authMode'),
          align: 'left',
          value: 'authMode',
          show: true
        },
        {
          text: this.$t('dataTable.header.credentials.email'),
          align: 'left',
          value: 'email',
          show: true
        },
        {
          text: this.$t('dataTable.header.actions'),
          align: 'right',
          value: 'actions',
          sortable: false,
          show: true
        }
      ],
      rules: {
        required: v => !!v || this.$t('validation.form.requiredField'),
        passwordMatch: v => (v === this.expAuthPwd.pwd) || this.$t('validation.form.passwordMustBeIdentical'),
        // minLenght: v => (v && v.length >= 6) || 'This field must have at least 6 characters'
        passwordMustBeLongerThan: v => (v && v.length >= this.passwordMinCharacters) || this.$t('validation.form.passwordMustBeLongerThan', { min: this.passwordMinCharacters }),
        onlyNumber: v => (/^[0-9]+$/.test(v)) || this.$t('validation.form.onlyNumbers'),
        atLeasOneDigit: (value) => (value && /\d/.test(value)) || 'At least one digit',
        atLeasOneLowerCaseLetter: (value) => (value && /[a-z]{1}/.test(value)) || 'At least one lowercase letter',
        atLeasOneUpperCaseLetter: (value) => (value && /[A-Z]{1}/.test(value)) || 'At least one capital letter',
        atLeasOneSpecialCharacter: (value) => (value && /[^A-Za-z0-9]/.test(value)) || 'At least one special character'
      },
      showNoDevicesModal: false,
      // implicitAuthorizationModal
      implicitAuthorizationModalKey: 0,
      ImplicitAuthorizationModalVisible: false,
      devicesListTotalItems: 0
    }
  },

  computed: {
    ...mapGetters(['hasRole']),
    isAdmin() {
      return this.hasRole(Role.ADMIN)
    },
    disableWhenadminOnlyCredentialManagement() {
      const adminOnlyCredentialManagement = this.$store.state.remoteConfig && this.$store.state.remoteConfig.adminOnlyCredentialManagement
      return this.isAdmin || !adminOnlyCredentialManagement
    },
    _headers() {
      const isAdmin = this.hasRole(Role.ADMIN)
      // todo search better solution to hide header column
      // eslint-disable-next-line vue/no-side-effects-in-computed-properties
      /* this.headers[5].show = isAdmin
      // eslint-disable-next-line vue/no-side-effects-in-computed-properties
      this.headers[6].show = isAdmin */
      return this.headers.filter(x => x.show)
    },
    showImportCredential() {
      return true
    }
  },

  watch: {
    search() {
      this.dataTableLoading = true
      this.searchCredentialsWatcher()
    },
    pagination: {
      handler(ev) {
        this.searchCredentials()
      }
    }
  },

  async mounted() {
    this.pageNum = this.$route.query.pageNum ? Number(this.$route.query.pageNum) : 1 || 1
    this.pagination.page = this.pageNum
    this.sortBy = this.$route.query.sortBy ? [this.$route.query.sortBy] : ['createdAt']
    this.pagination.sortBy = this.sortBy
    // eslint-disable-next-line no-unneeded-ternary
    this.pagination.sortDesc[0] = this.$route.query.sortOrder ? (this.$route.query.sortOrder === 'desc' ? true : false) : true

    this.searchCredentials()
  },

  methods: {
    gotoPage(page) {
      this.$nextTick(() => {
        this.pagination.page = page
      })
    },

    pageChange(newPage) {
      this.$router.replace({ name: 'ImportedCredentialsAdmin', query: { pageNum: newPage, sortBy: this.pagination.sortBy[0], sortOrder: this.pagination.sortDesc[0] ? 'desc' : 'asc' } })
    },

    sortTable() {
      this.$router.replace({ name: 'ImportedCredentialsAdmin', query: { pageNum: this.pagination.page, sortBy: this.pagination.sortBy[0], sortOrder: this.pagination.sortDesc[0] ? 'desc' : 'asc' } })
    },

    currentUser() {
      return this.$store.state.currentUser
    },

    async searchCredentials() {
      this.dataTableLoading = true

      let realSortField = this.pagination.sortBy[0]
      if (realSortField === 'user') {
        realSortField = 'user.name'
      } else if (realSortField === 'email') {
        realSortField = 'user.email'
      }

      const pageRequest = {
        'page-num': this.pagination.page || 1,
        'page-size': this.pagination.itemsPerPage || 10,
        'sort-field': realSortField,
        'sort-order': this.pagination.sortDesc !== undefined ? (this.pagination.sortDesc[0] ? 'desc' : 'asc') : 'desc'
      }

      try {
        const page = this.isAdmin ? await credentialRefs.listCredentialRefs(null, this.search, pageRequest) : await credentialRefs.listCredentialRefs(null, this.search, pageRequest)
        this.credentialList = page.content
        this.totalItems = page.total
        this.pagination.page = page.pageNum

        // activationLoading
        this.credentialList.forEach(element => {
          this.$set(this.credentialTableActivationBtnLoading, element.id, false)
        })
      } catch (error) {
        showToastError(this.getErrorMessage(error))
      } finally {
        this.dataTableLoading = false
      }
    },

    searchCredentialsWatcher: debounce(function() {
      this.searchCredentials()
    }, 500),

    showPasswordActions(item) {
      return (!this.isAdmin || (item.user.id === this.currentUser().id))
    },

    async deleteCredential(id, e) {
      const title = this.$t('dialog.confirmation.title')
      const conf = await showConfirmationMenu({ title: title, posX: e.clientX, posY: e.clientY })
      // const conf = await showConfirmationMenu({ title: this.$t('dialog.confirmation.title'), posX: e.clientX, posY: e.clientY })
      if (!conf) {
        return
      }

      try {
        await credentialRefs.deleteCredentialRef(id)
        this.searchCredentials()
        showToastSuccess(this.$t('toastMessage.succesfullyDeleted'))
      } catch (error) {
        const errorMsg = this.getErrorMessage(error)
        showToastError(errorMsg)
      }
    },

    isExplicitCredential(authMode) {
      return authMode === AuthMode.EXPLICIT
    },

    isImplicitCredential(authMode) {
      return authMode === AuthMode.IMPLICIT
    },

    getChipStyle(item) {
      if (item.status === 'ACTIVATED') {
        return 'statusEnabled'
      } else {
        return 'statusInactive'
      }
    },

    getKeyPurposeText(item) {
      return this.$t(`credentials.content.keyPurposeLabels.${item.keyPurpose}`)
    },

    getAuthModeText(item) {
      return this.$t('credentials.content.importedAuthMode')
    }

  }

}
</script>

<style scoped>
.statusEnabled,
.statusInactive {
  /*font-style: normal;
font-weight: 700;
font-size: 10px !important;
line-height: 12px;*/
}

/*.enabled {
  background-color: #e7ffd9 !important;
  color: #64c636 !important;
}
.inactive {
  background-color: #FFF4DC !important;
  color: #FDB714 !important;
}*/
</style>
